import { useMemo } from 'react';
import shortid from 'shortid';

export const useId = (...listeners: any[]) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const id = useMemo(() => shortid(), listeners);
  return id;
};
